import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';
import { gsap } from 'gsap';
import SplitText from 'gsap/SplitText';
import Viewport from '@/store/modules/Viewport';


export default /*#__PURE__*/_defineComponent({
  __name: 'LineByLine',
  props: {
  debug: {
    type: Boolean,
    default: false
  },
  tag: {
    type: String,
    default: 'div'
  },
  overflow: {
    type: Boolean,
    default: true
  },
  auto: {
    type: Boolean,
    default: true
  },
  delay: {
    type: Number,
    default: 0
  },
  animated: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const props = __props;

gsap.registerPlugin(SplitText);



const textSplited = ref<SplitText>()
const textSplitedParent = ref<SplitText>()
const oldWindowWidth = ref<number>(0)
const root = ref<HTMLElement>()
const init = ref<boolean>(false)
const played = ref<boolean>(false)

onMounted(() => {
  onResize()

  if (props.animated) {
    if (props.auto) onEnter()
  }

  window.addEventListener('resize', onResize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
})

const onResize = async() => {
  if (Viewport.windowWidth === oldWindowWidth.value) return
  oldWindowWidth.value = Viewport.windowWidth

  root.value.style.height = null

  if (textSplited.value || textSplitedParent.value) {
    textSplitedParent.value.revert()
    textSplited.value.revert()
  }

  await nextTick()
  
  textSplited.value = new SplitText(root.value, { type: 'lines', linesClass: 'Line' });
  
  if (props.overflow) {
    textSplitedParent.value = new SplitText(root.value, { type: 'lines', linesClass: 'Line__Parent' });
  }

  init.value = true
  if (props.animated as boolean) {
    onEnter()
  }
}

const onEnter = () => {
  const tl = gsap.timeline({ delay: props.delay as number });
  if (init.value && !played.value) {
    played.value = true
    const $ = gsap.utils.selector(root.value)
      tl.from([$('.Line')], {
        yPercent: (index) => 100 * (index+1),
        clearProps: 'all',
        textAlign: 'center',
        duration: 1,
        ease: 'quart.out',
      }, 'start')
  }

  return tl
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), {
    ref_key: "root",
    ref: root
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 512))
}
}

})